import { ruleOutcomeTypes } from "../redux/Types";

export const activityLimitActions = (abuseFlag) => {
  if (
    abuseFlag === ruleOutcomeTypes.LOGOUT ||
    abuseFlag === ruleOutcomeTypes.DEACTIVATE
  )
    // Logout user
    window.location.replace(`/logoutWithRedirect`);
};
